import { Outlet } from "react-router"
import { useParams } from "../../../../router"
import { VisaBasicDetails } from "../../../../Visa"
import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"

export default function VisaServiceDetailsLayout() {
	const { visaServiceId } = useParams("/visa/:visaServiceId")
	return (
		<>
			<Helmet>
				<title>Visa Service Details</title>
			</Helmet>
			<ForbidUnlessAuthorized
				permission={PERMISSIONS.VIEW_VISA_SERVICES}
			>
				<VisaBasicDetails visaServiceId={visaServiceId}>
					{({ service, onSuccess }) => <Outlet context={{ service, onSuccess }} />}
				</VisaBasicDetails>
			</ForbidUnlessAuthorized>
		</>
	)
}
